/**
 * Client-side cookie utility
 * A lightweight replacement for js-cookie using native browser APIs
 */

interface CookieOptions {
  expires?: number | Date
  path?: string
  domain?: string
  secure?: boolean
  sameSite?: "strict" | "lax" | "none"
}

export const clientCookies = {
  get(name: string): string | undefined {
    if (typeof document === "undefined") return undefined

    const value = `; ${document.cookie}`
    const parts = value.split(`; ${name}=`)

    if (parts.length === 2) {
      const cookieValue = parts.pop()?.split(";").shift()
      return cookieValue ? decodeURIComponent(cookieValue) : undefined
    }

    return undefined
  },

  set(name: string, value: string, options: CookieOptions = {}): void {
    if (typeof document === "undefined") return

    let cookieString = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`

    if (options.expires) {
      let expires: Date
      if (typeof options.expires === "number") {
        expires = new Date()
        expires.setTime(
          expires.getTime() + options.expires * 24 * 60 * 60 * 1000,
        )
      } else {
        expires = options.expires
      }
      cookieString += `; expires=${expires.toUTCString()}`
    }

    cookieString += `; path=${options.path || "/"}`

    if (options.domain) {
      cookieString += `; domain=${options.domain}`
    }

    if (options.secure) {
      cookieString += "; secure"
    }

    if (options.sameSite) {
      cookieString += `; samesite=${options.sameSite}`
    }

    document.cookie = cookieString
  },

  remove(name: string, options: CookieOptions = {}): void {
    this.set(name, "", {
      ...options,
      expires: new Date(0),
    })
  },
}
